export const getConfig = () => ({
  company: process.env.REACT_APP_COMPANY,
  baseUrl: process.env.REACT_APP_API_URL,
})